import React, { useState, useEffect } from "react";
import FormLayout from "../form-layout";
import Step3No from "./rejection-modal";
import { checkImmediateRed } from "../../lib/eligibility";

// Q19 — only reachable for patients who selected "Female" at the gender question.
export default function Step10A({ formData, setFormData, onBack, goToStep }) {
  const [answer, setAnswer] = useState(
    formData.pregnancyStatus || localStorage.getItem("pregnancyStatus") || ""
  );
      const [showModal, setShowModal] = useState(false);

  const options = ["Yes", "No"];

  // Which screen actually precedes this one depends on how much of the Q13-18
  // pathway ran:
  //  - Form B: the whole pathway is skipped (see allergy-check.jsx) -> back to "10"
  //  - Form A, Q13 answered "None of the above": 14-18 skipped -> back to "13"
  //  - Form A, Q13 answered a real medication: full 14-18 ran -> default back ("18") is correct
  const handleBack = () => {
    if (formData.glp1History === "current") {
      goToStep("10");
    } else if (!formData.glp1TriedMedication || formData.glp1TriedMedication === "none") {
      goToStep("13");
    } else {
      onBack();
    }
  };

  useEffect(() => {
    if (answer) {
      localStorage.setItem("pregnancyStatus", answer);
    }
  }, [answer]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const nextFormData = { ...formData, pregnancyStatus: answer };
    setFormData(nextFormData);

    if (checkImmediateRed(nextFormData)) {
      setShowModal(true);
    } else {
      goToStep("pregnancyNotice");
    }
  };
    const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <FormLayout title="" goToStep={goToStep} onBack={handleBack}>
        <h2 className="text-sm sm:text-[14px] font-medium text-[#000000] mb-2 text-center">
          Are you currently pregnant, breastfeeding, or planning a pregnancy in the next 2 months?
        </h2>

        <p className="text-gray-500 mb-6 text-sm text-center">
          Please select one option to continue.
        </p>

        <form onSubmit={handleSubmit}>
          <ul className="flex flex-col gap-3 mb-6 list-none p-0">
            {options.map((option) => {
              const isSelected = answer === option;
              return (
                <li key={option}>
                  <label
                    className={`flex items-start justify-start p-3 rounded-lg cursor-pointer border transition-all text-sm sm:text-[14px] font-medium
                      `}
                  >
                    <input
                      type="radio"
                      checked={isSelected}
                      onChange={() => setAnswer(option)}
                      className="h-4 w-4 accent-sky-400 cursor-pointer"
                    />
                    <span className="ml-2 text-gray-800">{option}</span>
                  </label>
                </li>
              );
            })}
          </ul>

          <div className="flex justify-start">
            <button
              type="submit"
              disabled={!answer}
              className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
                ${!answer ? "bg-gray-300 text-gray-600 cursor-not-allowed" : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"}`}
            >
              Next →
            </button>
          </div>
        </form>
     {showModal && (
          <Step3No
            onClose={handleCloseModal}
            formData={formData}
            setFormData={setFormData}
          />
        )}
      </FormLayout>

    </>
  );
}
